<template>
    <div style="position: relative">
        <data-table v-if="tableShow" :module-info="moduleInfo" :tb-columns="tableList" :toolbar-btns="listpageBtns" :on-list-data-before-load="onListDataBeforeLoad" :on-list-data-loaded="onListDataLoaded" :on-cell-click="cellclick" :on-selected-rows-change="selectedRowsChange">
            <div slot="toolbarLeft-slotLeft" style="line-height: 32px; color: #606266; font-size: 14px">
                <span>{{ $tx('gwgl.gdgl.recursionFile', { dataType: num }, `当前归档文件${num}件`) }}</span>
            </div>
        </data-table>
        <Basicform :title="title" :win-width="moduleInfo.winWidth" :win-height="moduleInfo.winHeight" :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened" :on-basic-form-before-submit="onBasicFormBeforeSubmit" :wf-attach="true" :batch-save-namefield="'attachmentName'">
            <template #default="slotProps">
                <FileForm :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
            </template>
        </Basicform>
        <FilingSystem />
    </div>
</template>

<script>
import FileForm from './FileForm'
import qs from 'qs'
import FilingSystem from '../../components/FilingSystem'

const moment = require('moment')

export default {
    components: {
        FileForm,
        FilingSystem
    },
    props: {
        searchType: {
            type: String,
            default: function () {
                return '0'
            }
        },
        treeNode: {
            type: Object,
            default: function () {
                return {}
            }
        },
        editPermission: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        language: {
            type: Array,
            default: function () {
                return []
            }
        },
        gdflszVos: {
            type: Array,
            default: function () {
                return []
            }
        },
        mapList: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            i18npkg: 'gwgl',
            moduleCode: 'gdgl',
            title: '归档文件',
            loginUser: this.$store.getters.loginUser,
            tableShow: false,
            moduleInfo: {
                getByIdUrl: 'gwgl/gdwj/getById',
                listDataUrl: 'gwgl/gdwj/archiveQuery',
                moduleCode: 'gwgl',
                addNewUrl: 'gwgl/gdwj/addNew',
                insertUrl: 'gwgl/gdwj/insert',
                updateUrl: 'gwgl/gdwj/update',
                uploadUrl: 'gwgl/gdwj/upload',
                winWidth: 1000, // 查看、编辑窗口宽度
                winHeight: 650 // 查看、编辑窗口高度
            },
            tableList: [
                {
                    field: 'state',
                    checkbox: true,
                    width: '45px'
                },
                {
                    field: 'index',
                    title: '序号',
                    width: '45px',
                    align: 'center',
                    valign: 'middle'
                },
                { propFormatter: 'component：@/wapp/gwgl/components/GwglTbColumns', listAdvSearchElement: '', field: 'flELevel', width: '100px', elementFormatter: this.$tx('gwgl.gdgl.flELevelFormatter', '平件：平件\n急件：急件\n特急：特急'), sortable: false, propType: 'String', align: 'center', title: '紧急程度 ', searchable: false },
                {
                    field: 'flSubject',
                    title: '文件标题',
                    align: 'left',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    searchable: true,
                    sortable: false,
                    listAdvSearchElement: 'input',
                    listAdvSearchIndex: 0
                },
                {
                    field: 'flGwType',
                    title: '公文种类',
                    width: '100px',
                    align: 'center',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    sortable: true,
                    searchable: true,
                    listAdvSearchElement: 'select',
                    listAdvSearchIndex: 3,
                    elementFormatter: '单位发文：单位发文\r\n收文阅办：收文阅办\r\n文件传阅：文件传阅\r\n请示报告：请示报告\r\n部门便函：部门便函\r\n单位函：单位函\r\n办公室文件：办公室文件\r\n'
                    // elementFormatter: this.$tx('gwgl.gdgl.flGwTypeElementFormatter')
                },
                {
                    field: 'gdType',
                    title: '归档类型',
                    width: '100px',
                    align: 'center',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    sortable: true,
                    searchable: true,
                    listAdvSearchElement: 'select',
                    listAdvSearchIndex: 3,
                    elementFormatter: '1：电子归档\r\n2：纸质归档\r\n'
                    // elementFormatter: this.$tx('gwgl.gdgl.gdTypeElementFormatter')
                },
                {
                    field: 'flSLevel',
                    title: '密级',
                    width: '100px',
                    align: 'center',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    searchable: false,
                    sortable: true,
                    listAdvSearchElement: 'input',
                    listAdvSearchIndex: 2,
                    elementFormatter: '1：一般\r\n2：特殊\r\n'
                    // elementFormatter: this.$tx('gwgl.gdgl.flSLevelElementFormatter')
                },
                {
                    field: 'creator',
                    title: '归档人',
                    width: '80px',
                    align: 'center',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    searchable: true,
                    sortable: false,
                    listAdvSearchElement: 'input',
                    listAdvSearchIndex: 3
                },
                {
                    field: 'gdTime',
                    title: '归档日期',
                    width: '160px',
                    align: 'center',
                    valign: 'middle',
                    cellStyle: { css: { cursor: 'pointer' } },
                    searchable: true,
                    sortable: true,
                    listAdvSearchElement: 'date',
                    elementFormatter: 'format：yyyy年MM月dd日\r\n',
                    listAdvSearchIndex: 4
                },
                {
                    field: 'fl',
                    title: '文件分类',
                    width: '100',
                    align: 'center',
                    valign: 'middle',
                    enabled: false,
                    cellStyle: { css: { cursor: 'pointer' } },
                    searchable: false,
                    sortable: false,
                    listAdvSearchElement: 'select',
                    listAdvSearchIndex: 2,
                    elementFormatter: ''
                }
            ],
            // 列表页面操作按钮定义
            listpageBtns: [],
            listpageBtnsb: [
                {
                    btnName: this.$tx('gwgl.gdgl.borrowingApplication', '借阅申请'),
                    btnIcon: 'plus',
                    btnClick: this.jieyuesq,
                    btnPermission: '',
                    id: 'btn_add',
                    btnType: 'toolbar'
                },
                {
                    btnName: this.$tx('pageBtns.export', '导出'),
                    btnIcon: 'export.svg',
                    btnClick: this.doloadFile,
                    btnPermission: '',
                    id: 'btn_download',
                    btnType: 'toolbar'
                }
            ],
            listpageBtnsa: [
                {
                    btnName: '新增',
                    btnIcon: 'plus',
                    btnClick: this.addObject,
                    btnPermission: '',
                    id: 'btn_add',
                    btnType: 'toolbar',
                    btnI18nCode: 'add'
                },

                {
                    id: 'btn_seetingId',
                    btnName: this.$tx('pageBtns.setting', '设置'),
                    btnIcon: 's-tools',
                    btnClick: this.setting,
                    btnPermission: 'setting',
                    btnType: 'toolbar'
                },
                {
                    btnName: this.$tx('pageBtns.export', '导出'),
                    btnIcon: 'export.svg',
                    btnClick: this.doloadFile,
                    btnPermission: '',
                    id: 'btn_export',
                    btnType: 'toolbar',
                    btnI18nCode: 'export'
                },
                {
                    btnName: '批量下载',
                    btnIcon: 'export.svg',
                    btnClick: this.batchSaveFiles,
                    btnPermission: 'batchSaveAllFiles',
                    id: 'btn_export',
                    btnType: 'toolbar',
                    btnI18nCode: 'batchSaveAllFiles'
                },
                {
                    id: 'btn_deleteId',
                    btnName: this.$tx('pageBtns.setting', '设置'),
                    btnIcon: '',
                    btnClick: this.setting,
                    btnPermission: 'setting',
                    btnType: 'column'
                }
            ],
            downloadFileTitle: [
                { title: '序号', width: 45, align: 'center', colspan: 1, rowspan: 1, code: 'index' },
                { title: '紧急程度', width: 100, align: 'center', colspan: 1, rowspan: 1, code: 'flELevel' },
                { title: '文件标题', width: 300, align: 'left', colspan: 1, rowspan: 1, code: 'flSubject' },
                { title: '文件类型', width: 100, align: 'center', colspan: 1, rowspan: 1, code: 'flGwType' },
                { title: '归档类型', width: 100, align: 'center', colspan: 1, rowspan: 1, code: 'gdType' },
                { title: '密级', width: 100, align: 'center', colspan: 1, rowspan: 1, code: 'flSLevel' },
                { title: '归档人', width: 80, align: 'center', colspan: 1, rowspan: 1, code: 'creator' },
                { title: '归档日期', width: 150, align: 'center', colspan: 1, rowspan: 1, code: 'gdTime' }
            ],
            canEdit: 1,
            rowsSelected: [], // 批量设置
            num: '',
            allDate: [],
            cellNot: true
        }
    },
    computed: {},
    watch: {
        treeNode() {
            this.setListDataUrl()
        }
    },
    created() {
        this.$bus.on('fileSetting', this.setting)
        this.$bus.on('editorForm', this.editorForm)
        this.listpageBtns = this.editPermission ? this.listpageBtnsa : this.listpageBtnsb
        if (this.editPermission) {
            this.tableList.push({
                field: 'operate',
                title: '操作',
                width: '100px',
                align: 'center',
                valign: 'middle',
                propFormatter: 'component：@/wapp/gwgl/components/GwglTbColumns'
            })
        }

        this.setListDataUrl()
    },
    beforeDestroy() {
        this.$bus.off('fileSetting', this.setting)
        this.$bus.off('editorForm', this.editorForm)
    },
    mounted() {
        console.log('listpageBtns', this.listpageBtns)

        let str = '：全部文种\r\n'
        this.language.forEach((item) => {
            str += item.name + '：' + item.name + '\r\n'
        })
        this.tableList[3].elementFormatter = str
    },
    methods: {
        jieyuesq() {
            if (this.rowsSelected.length > 0) {
                const gwjyInnerList = JSON.stringify(this.rowsSelected)
                localStorage.setItem('gwjyInnerList', gwjyInnerList)
                const newWindow = window.open(`#/wflow?wfEngineUrl=gwgl/jysq&busiCode=gwJysq&wfName=借阅申请&startNodeName=&gwjy=1`)
                var checkIfClosed = setInterval(function () {
                    if (newWindow.closed) {
                        console.log('新窗口已被关闭')
                        clearInterval(checkIfClosed)
                        localStorage.removeItem('gwjyInnerList')
                    }
                }, 1000)
            } else {
                this.$message.warning(this.$tx('gwgl.messages.selectData', '请先选择数据！'))
            }
        },
        onListDataBeforeLoad($scope, qparams) {
            if (!qparams.searchAndOr) {
                qparams.searchAndOr = 'or'
                qparams.searchMap['flSubject'] = ''
                qparams.searchMap['flGwType'] = ''
                qparams.searchMap['gdType'] = ''
                qparams.searchMap['creator'] = ''
                qparams.searchMap['gdTime'] = ''
            }
            qparams.orderBy = 'gdTime desc'
        },
        onListDataLoaded($scope, pageInfo) {
            console.log(284, pageInfo)
            this.allDate = pageInfo.list
            this.$http({
                url: '/gwgl/gdwj/numberOfArchives',
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded'
            }).then((res) => {
                if (res.code === 'success') {
                    this.num = res.body.num
                }
            })
        },
        selectedRowsChange(rows) {
            this.rowsSelected = rows
        },
        addObject() {
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, null, 1)
            })
        },
        setting(row) {
            let list = []
            if (row) list = [row]
            else list = this.rowsSelected
            this.cellNot = false
            this.$bus.emit('openDialog', { rowsSelected: list, url: '', edit: true })
            setTimeout(() => {
                this.cellNot = true
            }, 1000)
        },
        editorForm(row) {
            this.cellNot = false
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, row, 1)
            })
            setTimeout(() => {
                this.cellNot = true
            }, 1000)
        },
        cellclick(row, column, innerText, cellIndex) {
            debugger
            if (!this.editPermission) return
            if (!this.cellNot) return
            if (row.wfEngineUrl === undefined) {
                let wfEngineUrl = this.moduleInfo.listDataUrl.split('/')
                wfEngineUrl = encodeURI(wfEngineUrl[0] + '/' + wfEngineUrl[1])
                row.wfEngineUrl = '/wflow?wfEngineUrl=' + wfEngineUrl + '&busiDataId=' + row.id
            }
            window.open('./#' + row.wfEngineUrl + '&gdId=' + row.id)
        },
        async setListDataUrl() {
            let listDataUrl = ''
            if (this.searchType === '0') {
                if (this.treeNode.id === '0') {
                    listDataUrl = 'gwgl/gdwj/archiveQuery' // 全部
                } else if (this.treeNode.id === '1') {
                    listDataUrl = 'gwgl/gdwj/archiveQuery?categoryId=-1' // 未分类
                } else {
                    listDataUrl = 'gwgl/gdwj/archiveQuery?categoryId=' + this.treeNode.id
                }
            } else if (this.searchType === '1') {
                if (this.treeNode.id === '0') {
                    listDataUrl = 'gwgl/gdwj/archiveQuery'
                } else {
                    listDataUrl = 'gwgl/gdwj/archiveQuery?keyDate=' + this.treeNode.name
                }
            } else if (this.searchType === '2') {
                if (this.treeNode.id === '0') {
                    listDataUrl = 'gwgl/gdwj/archiveQuery'
                } else {
                    listDataUrl = 'gwgl/gdwj/archiveQuery?flGwType=' + this.treeNode.name
                }
            }
            this.tableShow = false
            // this.listpageBtns = this.editPermission ? this.listpageBtnsa : this.listpageBtnsb
            this.$nextTick(() => {
                this.tableShow = true
            })
            this.$set(this.moduleInfo, 'listDataUrl', listDataUrl)
        },
        async doloadFile() {
            // const res = await this.$app.listdata(this.moduleInfo.listDataUrl, { pageNum: 1 })
            // if (res.code === 'success') {
            let fileList = this.rowsSelected // res.body.pageInfo.list
            console.log(355, this.rowsSelected)
            console.log(358, this.allDate)
            if (fileList.length === 0) {
                fileList = this.allDate
                // this.$alert('暂无数据', '操作提示', {
                //     confirmButtonText: '确定',
                //     type: 'warning'
                // })
                // return
            }
            const rows = []
            fileList.forEach((item, i) => {
                const rowData = []
                this.downloadFileTitle.forEach((title) => {
                    const cellData = { value: '', align: '', colspan: 1, rowspan: 1 }
                    if (title.code === 'index') {
                        cellData.value = i + 1
                    } else if (title.code === 'gdType') {
                        cellData.value = item[title.code] === 1 ? this.$tx('gwgl.components.electronicFilling', '电子归档') : this.$tx('gwgl.components.paperArchiving', '纸质归档')
                    } else if (title.code === 'gdTime') {
                        cellData.value = moment(item[title.code]).format('YYYY年MM月DD日')
                    } else {
                        cellData.value = item[title.code]
                    }
                    cellData.align = title.align
                    rowData.push(cellData)
                })
                rows.push(rowData)
            })
            this.$http({
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
                data: qs.stringify({ rows: JSON.stringify(rows), titles: JSON.stringify([this.downloadFileTitle]), fileName: this.treeNode.name + '-归档文件' }),
                url: 'common/exportXlsFile'
            }).then((res) => {
                if (res.code === 'success') {
                    window.open('/apigw/' + res.body.xlsurl, '_blank')
                } else {
                    this.$message.error(res.message)
                }
            })
            // } else {
            // this.$message.error(res.message)
            // }
        },
        async batchSaveFiles() {
            if (this.rowsSelected.length === 0) {
                this.$alert('请选择要下载的文件', '操作提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                })
                return
            }
            this.$http({
                method: 'POST',
                url: '/gwgl/webForm/gwgdBatchDownload',
                data: this.rowsSelected
            }).then((res) => {
                if (res.code === 'success') {
                    window.open('/apigw/' + res.body.zipurl)
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        onBasicFormBeforeOpen($scope, vo, defer) {
            if (vo.isnew) {
                vo.accessRightsType = 0
                vo.creator = this.loginUser.personName
                vo.flGwType = vo.passenger.flGwTypeOptions[0].name
                // vo.wfNodeNames = vo.passenger.flGwTypeOptions[0].wfEngineUrl
            }
            defer.resolve(true)
        },
        onBasicFormOpened($scope, vo) {
            if ($scope.isnew) {
                vo.gdType = 2
            }
        },
        onBasicFormBeforeSubmit($scope, vo, defer) {
            if (vo.categoryName === '归档分类') {
                vo.categoryId = ''
                vo.categoryName = ''
            }
            this.$set(vo, 'wfEngineUrl', '/wflow?wfEngineUrl=gwgl/gdwj&busiDataId=' + vo.id)
            defer.resolve(true)
        }
    }
}
</script>

<style scoped lang="scss">
</style>
